const scrollTo = (id) => {
    const element = document.getElementById(id)
    console.log(element.offsetTop + 300 )
    window.scrollTo({
      behavior: element ? "smooth" : "auto",
      top: element ? element.offsetTop - 80 : 0,
    })
  }

  export { scrollTo}